// Bible chapter URLs are built from the chapter's own heading, which is free
// text an admin types -- "Costume Levels & RGL", "Covers, Lateness, No Shows".
// Concatenating that straight onto a path put spaces and ampersands into the
// URL, and while a browser encodes them correctly (%20, %26) plenty of other
// software does not.
//
// The case that forced this: Alan's RAG bot answers a question, then links the
// reader to the chapter for the pictures it cannot show. Its link detector ends
// the URL at the first space, so
//
//   .../skimpy_bible/Costume%20Levels%20&%20RGL
//
// reached the reader as
//
//   .../skimpy_bible/Costume
//
// which is a different page. Chat clients, markdown renderers and plain-text
// email all end links the same way, so this was never specific to that bot.
//
// A slug avoids the question entirely: no character in the output needs
// encoding, so there is nothing for a link parser to trip over.
export function bibleSlug(heading) {
	if (!heading) {
		return "";
	}

	return String(heading)
		.toLowerCase()
		// "&" carries meaning a reader expects to survive -- "Jug Runs & Tips"
		// becoming "jug-runs-tips" reads as though a word went missing.
		.replace(/&/g, " and ")
		// Everything not a-z 0-9 becomes a separator. Deliberately broad: it
		// covers punctuation nobody has typed into a heading yet.
		.replace(/[^a-z0-9]+/g, "-")
		.replace(/-{2,}/g, "-")
		.replace(/^-+|-+$/g, "");
}

// Whether a URL segment refers to this heading.
//
// Accepts the slug AND the raw heading, because URLs of the older form are
// already in circulation -- bookmarks, and the knowledge base the bot answers
// from. Those must keep working; a fix that breaks every existing link is not
// obviously better than the problem.
//
// The segment is decoded first. On a cold page load the pathname arrives
// percent-encoded ("ABN%20Instructions") while an in-app navigation supplies it
// raw ("ABN Instructions"), so comparing without decoding matches in one case
// and not the other.
export function bibleSlugMatches(heading, urlSegment) {
	if (!heading || !urlSegment) {
		return false;
	}

	let segment = String(urlSegment);
	try {
		segment = decodeURIComponent(segment);
	} catch (e) {
		// A malformed escape sequence throws. The raw segment is still worth
		// comparing, and it will simply not match.
	}

	return (
		segment === String(heading) ||
		bibleSlug(segment) === bibleSlug(heading)
	);
}
